module.exports = __webpack_public_path__ + "static/media/testimonials-1.2eb96321.jpg";